import { useEffect } from 'react';
import { Grid, Typography, TextField } from '@mui/material';
import { DatePicker, TimePicker } from '@mui/x-date-pickers';
import styles from './setGoal.module.scss'
import Paper from '../../../components/Paper';
import moment from 'moment';
import { isValidForNext, setIsClone } from '../createCampaignReducer';
import { useDispatch, useSelector } from 'react-redux';
import { setStep2MissingValue } from '../createCampaignReducer';
import { MISSING_VALUE_MESSAGE } from '../../../utils/constants';

const SetGoal = ({ state, setters, handlers, validation, validationSetters, nextStepValid, nextStepState, nextStepSetters }) => {
  const data = useSelector(store => store.createCampaign.attributeData.data)
  const dispatch = useDispatch()
  let minToTime
  if (state.date.from && state.date.to) {
    const fromDate = state.date.from.toDate()
    fromDate.setHours(0, 0, 0, 0)
    const toDate = state.date.to.toDate()
    toDate.setHours(0, 0, 0, 0)
    if (toDate.getTime() === fromDate.getTime()) {
      minToTime = state.time.from
    }
  }
  const handleInputChange = (event) => {
    // this function stops user to enter date manually from keyboard, only tab and enter key works on date picker
    if(event.key !== 'Tab' && event.key !== 'Enter'){
      event.preventDefault();
    }
  };

  const checkMissingValue = (stateAttributes) => {
    stateAttributes.attributes.forEach((item,index) => {
      if(!item.attribute && !item.operator && !item.value) return
      const attributeData = data.find(nestedItem => item.attribute === nestedItem.displayName)
      const operatorData = attributeData.operatorsAndValues.find(nestedItem => item.operator === nestedItem.displayName)
      if (Array.isArray(item.value)) {
          item.value.forEach((nestedItem) => {
              const obj = operatorData.values.valueList.find(doubleNestedItem => nestedItem === doubleNestedItem.displayName)
              if(obj) return
                  nextStepSetters.include.attributes(prevState => {
                    const newAttributes = [...prevState]
                    const attributeObj = {...newAttributes[index]}
                    attributeObj.value = []
                    newAttributes[index] = {...attributeObj} 
                    return newAttributes
                  })
                  dispatch(setStep2MissingValue(MISSING_VALUE_MESSAGE))
          })
      } else {
        const obj = operatorData.values.valueList.find(nestedItem => item.value === nestedItem.displayName)
        if(obj) return
            nextStepSetters.include.attributes(prevState => {
              const newAttributes = [...prevState] 
              const attributeObj = {...newAttributes[index]}
              attributeObj.value = ''
              newAttributes[index] = {...attributeObj}
              return newAttributes
            })
        dispatch(setStep2MissingValue(MISSING_VALUE_MESSAGE))
      }
    })

  }

  // logic to remove value of an attribute if it does not exists
  useEffect(()=>{
    const { include } = nextStepState;
    if(Object.keys(include.attributes[0]).length === 0) return
    checkMissingValue(include)
  },[])

  useEffect(()=>{
    dispatch(isValidForNext(nextStepValid))
    return () => {
      dispatch(setIsClone(false))
    }
  },[])

  return (
    <Paper heading="Step 1 - Set Goal">
      <Grid container className={styles.goalContainer} justifyContent="space-between" alignItems="baseline">
        <Grid container item xs={4}>
          <Grid item xs={12} className={styles.label}>What is your goal?<span className={styles.imp}>*</span></Grid>
          <Grid item xs={12}>
            <TextField fullWidth multiline rows={4} size='small' type="text" label="Set Goal" value={state.goal} onChange={handlers.goal} error={!validation.goal.valid && validation.goal.touched} onBlur={validationSetters.goal.touched} />
          </Grid>
        </Grid>
        <Grid container item xs={3}>
          <Grid item xs={12} className={styles.label}>Campaign Name<span className={styles.imp}>*</span></Grid>
          <Grid item xs={12}>
            <TextField fullWidth multiline rows={4} id='set-name' size='small' type="text" label="Campaign Name" value={state.campaignName} onChange={handlers.campaignName} error={!validation.campaignName.valid && validation.campaignName.touched} onBlur={validationSetters.campaignName.touched} />
          </Grid>
        </Grid>
        <Grid container item xs={4}>
          <Grid item xs={12} className={styles.labelWithSub}>Set Campaign Duration<span className={styles.imp}>*</span></Grid>
          <Grid item xs={12} marginBottom="5px">
            <Typography color="#959595" fontSize={10}>Date</Typography>
          </Grid>
          <Grid container item xs={12} justifyContent="space-between">
            <Grid item xs={5.5}>
              <DatePicker
                size='small'
                label="from"
                value={state.date.from}
                inputFormat="DD/MM/yyyy"
                onChange={setters.date.from}
                minDate={moment()}
                onClose={validationSetters.date.from.touched}
                disableMaskedInput
                renderInput={(params) => <TextField size='small' {...params} error={!validation.date.from.valid && validation.date.from.touched} onBlur={validationSetters.date.from.touched} onKeyDown={handleInputChange} onChange={handleInputChange} />}
              />
            </Grid>
            <Grid item xs={5.5}>
              <DatePicker
                size='small'
                label="to"
                value={state.date.to}
                inputFormat="DD/MM/yyyy"
                onChange={setters.date.to}
                onClose={validationSetters.date.to.touched}
                disabled={!state.date.from || !validation.date.from.valid}
                disableMaskedInput
                minDate={state.date.from}
                renderInput={(params) => <TextField size='small' {...params} error={!validation.date.to.valid && validation.date.to.touched} onBlur={validationSetters.date.to.touched} onKeyDown={handleInputChange} onChange={handleInputChange} />}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} sx={{ marginTop: "5px" }}>
            <Typography color="#959595" fontSize={10} marginBottom="5px">Time</Typography>
          </Grid>
          <Grid container item xs={12} justifyContent="space-between">
            <Grid item xs={5.5}>
              <TimePicker
                size='small'
                label="from"
                value={state.time.from}
                onChange={setters.time.from}
                renderInput={(params) => <TextField size='small' {...params} error={!validation.time.from.valid && validation.time.from.touched} onBlur={validationSetters.time.from.touched} />}
              />
            </Grid>
            <Grid item xs={5.5}>
              <TimePicker
                label="to"
                value={state.time.to}
                onChange={setters.time.to}
                minTime={minToTime}
                renderInput={(params) => <TextField size='small' {...params} error={!validation.time.to.valid && validation.time.to.touched} onBlur={validationSetters.time.to.touched} />}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
}

export default SetGoal
